// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-comment-moderation {
    text-align: right;
}
.post-comment-moderation svg {
    width: 20px;
    height: 20px;
    margin-bottom: -3px;
}
.post-comment-moderation__approve svg {
    color: var(--success-color-main);
}
.post-comment-moderation__remove svg {
    color: var(--danger-color-main);
}
.post-comment-moderation__flagged svg {
    color: var(--danger-color-main);
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostComment/PostCommentModeration/PostCommentModeration.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC","sourcesContent":[".post-comment-moderation {\n    text-align: right;\n}\n.post-comment-moderation svg {\n    width: 20px;\n    height: 20px;\n    margin-bottom: -3px;\n}\n.post-comment-moderation__approve svg {\n    color: var(--success-color-main);\n}\n.post-comment-moderation__remove svg {\n    color: var(--danger-color-main);\n}\n.post-comment-moderation__flagged svg {\n    color: var(--danger-color-main);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
